import axios from "axios";

/** Login failed (credentials, throttling, network, etc.) — always rethrown to the UI. */
export class AuthLoginError extends Error {
  readonly cause: unknown;

  constructor(cause: unknown) {
    const message =
      axios.isAxiosError(cause) && typeof cause.response?.data?.detail === "string"
        ? cause.response.data.detail
        : "LOGIN_FAILED";
    super(message);
    this.name = "AuthLoginError";
    this.cause = cause;
  }
}

export function toAuthLoginError(error: unknown): AuthLoginError {
  if (error instanceof AuthLoginError) {
    return error;
  }
  return new AuthLoginError(error);
}

export function isAuthLoginError(error: unknown): error is AuthLoginError {
  return error instanceof AuthLoginError;
}
